import noUiSlider from 'nouislider';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { toast } from 'react-toastify';

import 'nouislider/distribute/nouislider.css';
import { connect } from 'react-redux';
import { selectIsDownloadsEnabled } from '~/store';
import { routerLocationShape } from '../helpers/propTypeShapes';
import secondsToTimeString from '../helpers/secondsToTimeString';
import trackMixPanelEvent from '../helpers/trackMixPanelEvent';
import '../style/clipRecording.css';
import '../style/multirange.css';

class ClipRecording extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clipCurrentTime: '0',
      clipStartTime: '0',
      clipEndTime: this.props.clipVidDuration,
      clipsCreated: 0,
      clipsChecked: false,
      minClipLength: 5,
      player: null,
      slider: null,
    };

    this.closeModal = this.closeModal.bind(this);
    this.createClip = this.createClip.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.setClipTimes = this.setClipTimes.bind(this);
    this.setPlayhead = this.setPlayhead.bind(this);
    this.handleVideoRightClick = this.handleVideoRightClick.bind(this);
  }

  componentDidMount() {
    const that = this;
    const { videojs } = window;
    const playerElement = document.getElementById('clippingVideo');
    const player = videojs(
      playerElement,
      {
        loop: true,
        muted: true,
        controlBar: {
          volumePanel: {
            inline: false,
            vertical: true,
          },
        },
      },
      () => {
        player.play();
      }
    );

    const Button = videojs.getComponent('Button');
    const LoopButton = videojs.extend(Button, {
      constructor: function ctor(...args) {
        Button.apply(this, args);
        // eslint-disable-next-line no-underscore-dangle
        this.el_.id = 'loopButton';
        this.addClass('loop-button');
        this.addClass('active');
        this.controlText('loop');
      },
      handleClick: function click() {
        that.toggleLoopStatus();
      },
    });
    videojs.registerComponent('LoopButton', LoopButton);
    player.getChild('controlBar').addChild('loopButton', {}, 7);

    this.setState({
      player,
    });
    player.on('timeupdate', function timeupdate() {
      const currentTime = this.currentTime();

      if (currentTime > that.state.clipEndTime) {
        if (!player.loop()) {
          player.pause();
          this.currentTime(that.state.clipEndTime);
        } else {
          this.currentTime(that.state.clipStartTime);
        }
      }

      const playheadEl = document.getElementsByClassName('noUi-origin')[1];
      if (!player.paused() && !playheadEl.contains(document.activeElement)) {
        that.setPlayhead();
      }
    });

    const slider = document.getElementById('slider');

    noUiSlider.create(slider, {
      start: [0, 0, +this.props.clipVidDuration],
      connect: true,
      range: {
        min: 0,
        max: +this.props.clipVidDuration,
      },
      animate: false,
      behaviour: 'drag',
    });
    this.setState({
      slider,
    });
    slider.noUiSlider.on('update', (values) => {
      if (document.activeElement.className.includes('handle')) {
        this.handleSliderUpdates(values);
      }
    });

    slider.noUiSlider.on('set', () => {
      const arrHandles = document.getElementsByClassName('noUi-origin');

      // Force playhead to always appear on top of endpoints
      arrHandles[1].style.zIndex = +arrHandles[0].style.zIndex + +arrHandles[2].style.zIndex;
    });

    slider.noUiSlider.on('start', (values, handle) => {
      if (handle === 0 || handle === 2) {
        player.on('pause', this.hidePlayhead);
        if (!player.paused()) {
          player.pause();
        } else {
          this.hidePlayhead();
        }
      }
      if (handle === 0) {
        slider.noUiSlider.set([null, +values[0] + 1, null]);
      }
      if (handle === 2) {
        slider.noUiSlider.set([null, +values[2] - 1, null]);
      }
    });
    slider.noUiSlider.on('slide', (values, handle) => {
      if (handle === 0) {
        slider.noUiSlider.set([null, +values[2], null]);
      }
      if (handle === 2) {
        slider.noUiSlider.set([null, +values[0], null]);
      }
    });
    slider.noUiSlider.on('end', (values, handle) => {
      if (handle === 0 || handle === 2) {
        player.off('pause', this.hidePlayhead);
        this.state.player.currentTime(this.state.StartTime);
        this.showPlayhead();
      }
      if (handle === 1) {
        document.getElementsByClassName('noUi-handle')[1].blur();
      }
      if (handle === 0) {
        slider.noUiSlider.set([null, values[0], null]);
      }
      if (handle === 2) {
        slider.noUiSlider.set([null, values[2], null]);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.clipStartTime !== this.state.clipStartTime) {
      if (this.state.player && this.state.clipEndTime - this.state.clipStartTime >= this.state.minClipLength) {
        this.state.player.currentTime(this.state.clipStartTime);
        this.state.player.pause();
      } else if (this.state.player) {
        const fallbackTime = +this.state.clipEndTime - +this.state.minClipLength;

        this.state.player.currentTime(fallbackTime);
        this.state.slider.noUiSlider.set([fallbackTime, null, null]);
      }
    }
    if (prevState.clipCurrentTime !== this.state.clipCurrentTime) {
      if (this.state.player) {
        this.state.player.currentTime(this.state.clipCurrentTime);
      }
    }
    if (prevState.clipEndTime !== this.state.clipEndTime) {
      if (this.state.player && +this.state.clipEndTime - +this.state.clipStartTime >= this.state.minClipLength) {
        this.state.player.currentTime(this.state.clipEndTime);
        this.state.player.pause();
      } else if (this.state.player) {
        const fallbackTime = +this.state.clipStartTime + +this.state.minClipLength;

        this.state.player.currentTime(fallbackTime);
        this.state.slider.noUiSlider.set([null, null, fallbackTime]);
      }
    }
  }

  componentWillUnmount() {
    this.state.player.dispose();
    // this.state.slider.destroy();
  }

  handleVideoRightClick(event) {
    if (!this.props.isDownloadsEnabled) event?.preventDefault();
  }

  handleInputChange(event) {
    event.nativeEvent.stopImmediatePropagation();

    if (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13 || event.keyCode === undefined) {
      this.setClipTimes(event);
    } else {
      // td: remove manual dom manipulation
      const { target } = event;
      target.dataset.value = target.innerText;
    }
  }

  handleSliderUpdates(values) {
    const startInput = document.getElementById('clipStartTime');
    const endInput = document.getElementById('clipEndTime');

    startInput.value = secondsToTimeString(values[0]);
    endInput.value = secondsToTimeString(values[2]);
    this.setState({
      clipStartTime: values[0],
      clipCurrentTime: values[1],
      clipEndTime: values[2],
    });
  }

  getValueInMillis(value) {
    const valueInMillis = Math.round(value * 1000);

    return valueInMillis;
  }

  setClipTimes(event) {
    event.preventDefault();

    if (!document.activeElement.className.includes('handle')) {
      const { target } = event;
      let direction = 0;
      if (event.keyCode === 38 || event.keyCode === 40) {
        direction = -(event.keyCode - 39);
      } else {
        direction = 0;
      }
      const step = target.dataset.step || 1;
      const secs = this.timeToSeconds(target.value);
      const updatedSecs = this.setNumber(secs, step * direction);
      const newTime = parseFloat(Math.round(this.getValueInMillis(updatedSecs) * 0.001 * 100) / 100).toFixed(2);

      if (target.dataset.state === 'clipStartTime') {
        if (newTime >= 0 && newTime <= this.state.clipEndTime - this.state.minClipLength) {
          target.value = secondsToTimeString(updatedSecs);
          this.setState(
            {
              clipStartTime: newTime,
            },
            () => {
              this.state.slider.noUiSlider.set([this.state.clipStartTime, null, null]);
            }
          );
        } else {
          const fallbackTime = secondsToTimeString(secs);

          if (fallbackTime >= 0 && fallbackTime <= this.state.clipEndTime - this.state.minClipLength) {
            target.value = fallbackTime;
          } else if (event.keyCode === 40) {
            target.value = '0:00';
          } else {
            target.value = secondsToTimeString(this.state.clipEndTime - this.state.minClipLength);
          }
        }
        this.setPlayhead();
      } else if (target.dataset.state === 'clipEndTime') {
        if (
          newTime >= +this.state.clipStartTime + +this.state.minClipLength &&
          newTime <= +this.props.clipVidDuration
        ) {
          target.value = secondsToTimeString(updatedSecs);
          this.setState(
            {
              clipEndTime: newTime,
            },
            () => {
              this.state.slider.noUiSlider.set([null, null, this.state.clipEndTime]);
            }
          );
        } else {
          const fallbackTime = secondsToTimeString(secs);

          if (
            fallbackTime >= this.state.clipStartTime + this.state.minClipLength &&
            fallbackTime <= this.props.clipVidDuration
          ) {
            target.value = fallbackTime;
          } else if (event.keyCode === 38) {
            target.value = secondsToTimeString(this.props.clipVidDuration);
          } else {
            target.value = secondsToTimeString(+this.state.clipStartTime + this.state.minClipLength);
          }
        }
      }
      this.setPlayhead();
    }
  }

  setNumber(value, increment = 1) {
    const numValue = typeof value === 'string' ? this.timeToSeconds(value) : value;
    const sum = +numValue + increment;
    return sum;
  }

  setPlayhead() {
    this.state.slider.noUiSlider.set([null, this.state.player.currentTime(), null]);
  }

  hidePlayhead() {
    const playhead = document.getElementsByClassName('noUi-handle')[1];

    playhead.style.opacity = 0;
  }

  showPlayhead() {
    const playhead = document.getElementsByClassName('noUi-handle')[1];

    playhead.style.opacity = 1;
  }

  createClip() {
    const that = this;
    const params = {
      headers: {
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
        authorization: sessionStorage.getItem('authToken'),
      },
      method: 'POST',
      body: JSON.stringify({
        streamID: this.props.sourceId,
        startTime: parseFloat(this.state.clipStartTime),
        endTime: parseFloat(this.state.clipEndTime),
        title: `${this.props.broadcastTitle} - Clip ${secondsToTimeString(
          parseFloat(this.state.clipStartTime)
        )} to ${secondsToTimeString(parseFloat(this.state.clipEndTime))}`,
      }),
    };

    fetch(`${this.props.APIBaseURL}/clip/from-stream`, params)
      .then((response) => {
        if (response.status === 401) {
          this.props.trackEvent('401', {
            source: 'createClip (ClipRecording)',
          });
          // eslint-disable-next-line no-console
          console.error('Received 401 response from createClip (ClipRecording). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
          return undefined;
        }
        trackMixPanelEvent('Create clip', {
          Duration: parseFloat(this.state.clipEndTime) - parseFloat(this.state.clipStartTime),
          'Source Video': this.props.sourceId,
        });
        return response.json();
      })
      .then((data) => {
        const newClip = new CustomEvent('newClip', { detail: data.sessionHash });

        this.setState(
          (prevState) => ({ clipsCreated: prevState.clipsCreated + 1, clipsChecked: true }),
          () => {
            toast.success('Clip created');
            // TODO: refactor this into a store thunk + listener
            window.dispatchEvent(newClip);
            setTimeout(() => {
              that.setState({
                clipsChecked: false,
              });
            }, 1000);
          }
        );
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('error: ', error);
      });
  }

  closeModal() {
    this.props.closeModal();
  }

  timeToSeconds(str) {
    const a = str.split(':');
    let sum = 0;
    for (let i = 0; i < a.length; i += 1) {
      let v = +a[i];

      if (a.length - i === 2) {
        v = a[i] * 60;
      } else if (a.length - i > 2) {
        v = a[i] * 3600;
      }
      sum += v;
    }
    return sum;
  }

  toggleLoopStatus() {
    const loopButton = document.getElementById('loopButton');

    if (this.state.player.loop()) {
      this.state.player.loop(false);
      loopButton.classList.remove('active');
    } else {
      this.state.player.loop(true);
      loopButton.classList.add('active');
    }
  }

  validateInput(event) {
    const inputValue = event.data;
    const acceptedChars = [':'];

    if (acceptedChars.includes(inputValue)) {
      return true;
    }

    if (Number.isNaN(+event.target.innerText + inputValue)) {
      //	input is not valid, REJECT
      event.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
    }

    return false;
  }

  render() {
    let checked = '';
    let clipsCreatedClass = '';
    let clipsPlural = 'clip';

    if (this.state.clipsCreated > 0) {
      clipsCreatedClass = 'active';
    }
    if (this.state.clipsCreated > 1) {
      clipsPlural = 'clips';
    }
    if (this.state.clipsChecked) {
      checked = 'checked';
    }

    return (
      <div className="clipping-container">
        <div className="modal-header">
          <h2 className="modal-title">Clip Recording</h2>
          <button type="button" className="anchor modal-closer" onClick={this.closeModal}>
            &nbsp;
          </button>
        </div>
        <div className="clipping-inner-container">
          <p className="clipping-description">
            Use the sliders below to seek and create a downloadable clip for your video at the right length. If you
            select the timestamps you can use the arrow keys for adjustment.
          </p>
          <video
            id="clippingVideo"
            controls
            preload="auto"
            className="video-js vjs-default-skin vjs-16-9"
            poster={this.props.clipVidPoster}
            onContextMenu={this.handleVideoRightClick}
          >
            <source src={this.props.clipVidURL} type={this.props.clipVidType} />
          </video>
          <div className="clipping-controls-container">
            <input
              id="clipStartTime"
              autoComplete="off"
              data-step="0.01"
              min="0"
              className="clip-start-time"
              defaultValue={secondsToTimeString(Math.round(this.state.clipStartTime * 100) / 100)}
              data-state="clipStartTime"
              onBeforeInput={this.validateInput}
              onBlur={this.setClipTimes}
              onKeyDown={this.handleInputChange}
            />
            <div className="slider-container">
              <div id="slider" />
            </div>
            <input
              id="clipEndTime"
              autoComplete="off"
              data-step="0.01"
              max={this.props.clipVidDuration}
              className="clip-end-time"
              defaultValue={secondsToTimeString(Math.round(this.state.clipEndTime * 100) / 100)}
              data-state="clipEndTime"
              onBeforeInput={this.validateInput}
              onBlur={this.setClipTimes}
              onKeyDown={this.handleInputChange}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="modal-closer-text" onClick={this.closeModal}>
            Close
          </button>
          <div className={`clip-counter-container ${clipsCreatedClass} ${checked}`}>
            {this.state.clipsCreated} {clipsPlural} created
          </div>
          <button type="submit" id="createClip" className="btn med-blue create-clip" onClick={this.createClip}>
            Create clip
          </button>
        </div>
      </div>
    );
  }
}

ClipRecording.propTypes = {
  APIBaseURL: PropTypes.string.isRequired,
  broadcastTitle: PropTypes.string.isRequired,
  clipVidDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  clipVidPoster: PropTypes.string.isRequired,
  clipVidType: PropTypes.string.isRequired,
  clipVidURL: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  isDownloadsEnabled: PropTypes.bool.isRequired,
  location: routerLocationShape.isRequired,
  reAuth: PropTypes.func.isRequired,
  sourceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ isDownloadsEnabled: selectIsDownloadsEnabled(state) });
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClipRecording);
